import cookie from 'js-cookie'

import CONSTANT from './constant'

class Cache {
  constructor() {
    // localStorage、sessionStorage、memoryStorage、cookie
    // this.cacheMode = 'localStorage'
  }

  /**
   * 获取鉴权信息
   *
   * @returns
   */
  getAuth() {
    return cookie.get(CONSTANT.AUTH)
  }

  /**
   * 清空鉴权信息
   *
   */
  removeAuth() {
    cookie.remove(CONSTANT.AUTH)
  }
  /**
   * 设置用户信息
   *
   * @param {*} currentUserInfo 帐户信息
   * @returns
   */
  setCurrentUserInfo(currentUserInfo) {
    return peace.cache.localStorage.set(CONSTANT.CURRENT_USER_INFO, currentUserInfo)
  }
  /**
   * 设置用户信息
   *
   * @param {*}
   * @returns
   */
  getCurrentUserInfo() {
    return peace.cache.localStorage.get(CONSTANT.CURRENT_USER_INFO)
  }
  /**
   * 设置帐户信息
   *
   * @param {*} accountInfo 帐户信息
   * @returns
   */
  setAccountInfo(accountInfo) {
    return peace.cache.localStorage.set(CONSTANT.ACCOUNT_INFO, accountInfo)
  }

  /**
   * 获取帐户信息
   *
   * @returns
   */
  getAccountInfo() {
    return peace.cache.localStorage.get(CONSTANT.ACCOUNT_INFO)
  }

  /**
   * 清空帐户信息
   *
   */
  removeAccountInfo() {
    peace.cache.localStorage.remove(CONSTANT.ACCOUNT_INFO)
    peace.cache.localStorage.remove(CONSTANT.CURRENT_USER_INFO)
  }

  /**
   * 清空所有帐户信息
   *
   */
  removeAllAccountInfo() {
    peace.cache.localStorage.remove(CONSTANT.AUTH)

    peace.cache.localStorage.remove(CONSTANT.ACCOUNT_INFO)
    peace.cache.sessionStorage.remove(CONSTANT.ACCOUNT_MENU)
    peace.cache.localStorage.remove(CONSTANT.CURRENT_USER_INFO)
  }

  /**
   * 设置账户菜单信息
   *
   * @param {*} accountMenu 账户菜单信息
   * @returns
   */
  setAccountMenu(accountMenu) {
    return peace.cache.sessionStorage.set(CONSTANT.ACCOUNT_MENU, accountMenu)
  }

  /**
   * 获取账户菜单信息
   *
   * @returns
   */
  getAccountMenu() {
    return peace.cache.sessionStorage.get(CONSTANT.ACCOUNT_MENU)
  }

  /**
   * 清空账户菜单信息
   *
   */
  removeAccountMenu() {
    peace.cache.sessionStorage.remove(CONSTANT.ACCOUNT_MENU)
  }
}

export default new Cache()
